<!-- All Angular Component testing goes here: -->

<!-- Testing/setting feature flags ================================================ -->
<bulb-run-migrators></bulb-run-migrators>
<hr/>
<h2>Feature Flags</h2>
<table>
  <thead>
    <tr>
      <th>Feature Flag<br></th>
      <th>Status for Current User</th>
      <th>Enable for all existing Users<br/>(admin only)</th>
      <th>Enable for all future Users<br/>(admin only)</th>
      <th>Note</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let featureFlagStatus of featureFlagStatuses | keyvalue">
      <td>{{featureFlagStatus.key}}</td>
      <td><p-inputSwitch (onChange)="toggleFeatureFlag(featureFlagStatus.key)"
                 [(ngModel)]="featureFlagStatuses[featureFlagStatus.key]"
                 [disabled]="featureFlag.CKE === featureFlagStatus.key && featureFlagStatuses[featureFlagStatus.key]">
        ></p-inputSwitch></td>
      <td><aero-button [icon]="featureFlagIcons[featureFlagStatus.key].icon1"
               label="Enable"
               [disabled]="!currentUser.hasRole('ADMIN')"
               (onClick)="enableFeatureFlagForExistingUsers(featureFlagStatus.key)"></aero-button></td>
      <td><aero-button [icon]="featureFlagIcons[featureFlagStatus.key].icon2"
               label="Enable"
               [disabled]="!currentUser.hasRole('ADMIN')"
               (onClick)="enableGlobalFeatureFlag(featureFlagStatus.key)"></aero-button>
      </td>
      <td *ngIf="featureFlag.CKE === featureFlagStatus.key && featureFlagStatuses[featureFlagStatus.key]">
        If you want to disable CKE Feature then reset your db.</td>
    </tr>
  </tbody>
</table>
<br/>

<aero-accordion class="row">

  <!-- LTI Names and Roles -->
  <aero-accordion-tab panelValue="ltiNames"  class="columns medium-12">
    <span header>LTI Names and Roles</span>
    <div content>
      <bulb-lti-names-and-roles></bulb-lti-names-and-roles>
    </div>
  </aero-accordion-tab>

  <!-- Force page grooming job -->
  <aero-accordion-tab panelValue="pageGrooming"  class="columns medium-12">
    <span header>Page Grooming Job</span>
    <div content>
      <aero-button label="Run Weekly Page Grooming Job"
                   (onClick)="runArchivePageGroomingJob();">
      </aero-button>
      <div *ngIf="pageGroomingResponse">{{pageGroomingResponse}}</div>
    </div>
  </aero-accordion-tab>

  <!-- Force conversion of bulb+ accounts to free -->
  <aero-accordion-tab panelValue="convertFree"  class="columns medium-12">
    <span header>Convert bulb+ accounts to Free</span>
    <div content>
      <aero-button label="Weekly job for converting bulb+ accounts to Free"
                   (onClick)="convertBulbPlusAccountToFree();">
      </aero-button>
      <div *ngIf="accountUpdateResponse">{{accountUpdateResponse}}</div>
    </div>
  </aero-accordion-tab>

  <!-- Email Digest testing -->
  <aero-accordion-tab panelValue="emailDigest"  class="columns medium-12">
    <span header>Email Digests</span>
    <div content>
      <div *ngIf="currentUser.defaultEmail" class="row">
        <aero-button label="Toggle Daily Digest Email" class="bulb-email-digest"
                     (onClick)="toggleEmailDigest('DAILY');">
        </aero-button>
        <aero-button label="Toggle Weekly Digest Email"
                     (onClick)="toggleEmailDigest('WEEKLY');">
        </aero-button>
        <div *ngIf="emailDigestResponse">{{emailDigestResponse}}</div>
      </div>
    </div>
  </aero-accordion-tab>

  <!-- Page Content Generator -->
  <aero-accordion-tab panelValue="contentGenerator" class="columns medium-12">
    <span header>Page Content Generator</span>
    <div content>
      <aero-form submitButtonLabel='Run Content Generator'
                 [showCancelButton]="false"
                 (onSubmit)="generatePageContent()">
        <aero-input [type]="'number'"
                    [label]="'Page Content Generator'"
                    [name]="'contentPageCount'"
                    [placeholder]="'Number of Pages'"
                    [required]="true"
                    [(ngModel)]="contentPageCount"
                    [maxlength]="2">
        </aero-input>
      </aero-form>
      <div *ngIf="pageContentResponse" class="medium-12 columns">
        <pre>
          <div>{{pageContentResponse}}</div>
        </pre>
      </div>
    </div>
  </aero-accordion-tab>

  <!-- Template List Rule Generator -->
  <aero-accordion-tab panelValue="ruleGenerator"  class="columns medium-12">
    <span header>Template List Rule Generator</span>
    <div content>
      <aero-button label='Run Template List Rule Generator'
                   (onClick)="generateTemplatesAndListRules();">
      </aero-button>
      <div *ngIf="templateListRulesResponse" class="medium-12 columns">
        <pre>
          <div>{{templateListRulesResponse}}</div>
        </pre>
      </div>
    </div>
  </aero-accordion-tab>

  <!-- Stripe Product Configuration -->
  <aero-accordion-tab #stripeTab panelValue="stripeConfig"  class="columns medium-12">
    <span header>Stripe Product Setting</span>
    <div content *ngIf="stripeTab.selected">
      <span>
        Default product for standard and student are selected. If you want different products, Please select from below
      </span>
      <br><br>
      <div class="row">
        <div class="columns medium-12">
          <h5>Standard Product: </h5>
          <aero-dropdown
            [choices]="stripeProductList"
            [choicesField]="'productName'"
            [choicesType]="'object'"
            [selectedOption]="defaultStripeProduct.standard"
            [placeholder]="'Select Standard Product'"
            (communicating)="setStripeStandardProduct($event)"
          >
          </aero-dropdown>
          <br><br>
          <h5>Student Product: </h5>
          <aero-dropdown
            [choices]="stripeProductList"
            [choicesField]="'productName'"
            [choicesType]="'object'"
            [selectedOption]="defaultStripeProduct.student"
            [placeholder]="'Select Student Product'"
            (communicating)="setStripeStudentProduct($event)"
          >
          </aero-dropdown><br>
          <p><b> {{ stripeProductAPIResponseMessage }} </b></p>

          <aero-button label="Save Product"
                       (onClick)="saveProductData();">
          </aero-button>
        </div>
      </div>
    </div>
  </aero-accordion-tab>

  <!-- Resume Download link -->
  <aero-accordion-tab panelValue="resumeDownload" class="columns medium-12">
    <span header>Resume Download</span>
    <div content>
      <a href="{{'/b/rest/resumes/'+currentUser.resumeId+'/json'}}" target="_blank">Download JSON Resume</a>
    </div>
  </aero-accordion-tab>

  <!-- Sentry Logs -->
  <aero-accordion-tab panelValue="sentryLogs"  class="columns medium-12">
    <span header>Sentry Logs</span>
    <div content>
      <aero-button
        label={{buttonlabel}}
        (onClick)="toggleSentry(true)"></aero-button>
      <br/>
      <div *ngIf="sentryEnabledFlag">
        <div>
          <div>Sentry whitelist allows only certain system domains on the client side to send messages</div>
          <div></div>
          <aero-button label='Send Server & Client Test Error To Sentry'
                       (onClick)="sendTestSentryError();">
          </aero-button>
        </div>
        <div *ngIf="sentryResultMessage">{{sentryResultMessage}}</div>
      </div>
    </div>
  </aero-accordion-tab>

  <!-- Telemetry test -->
  <aero-accordion-tab panelValue="telemetryTest"  class="columns medium-12">
    <span header>Telemetry Test (Google Analytics)</span>
    <div content>
      <button
        bulbRecordEvent
        data-event-action="click debug page"
        data-event-category="test"
        data-event-label="example label"
        data-event-value="1"
      >Click me to record event!</button>
    </div>
  </aero-accordion-tab>

  <!-- Testing Radio buttons -->
  <aero-accordion-tab panelValue="radioButtons"  class="columns medium-12">
    <span header>Radio Buttons</span>
    <div content>
      <a href="#radio-button-test">
        <h2 id="radio-button-test">Testing Aero Radio Image Group ( with placeholder images )</h2>
      </a>
      <aero-image-radio-group>

        <aero-image-radio-button
          [(selectedImageId)]="selectedImage"
          [width]="100"
          [height]="100"
          [name]="'Next Station 2'"
          [imageSrc]="'resources/images/bulb_assetlibrary_google_docs.svg'">
        </aero-image-radio-button>
        <aero-image-radio-button
          [(selectedImageId)]="selectedImage"
          [name]="'Next Station 3'"
          [imageSrc]="'resources/images/bulb_assetlibrary_google_slides.svg'">
        </aero-image-radio-button>
        <aero-image-radio-button
          [(selectedImageId)]="selectedImage"
          [name]="'Next Station 4'"
          [imageSrc]="'resources/images/bulb_assetlibrary_google_sheets.svg'">
        </aero-image-radio-button>

      </aero-image-radio-group>

      <p>The value: {{ selectedImage }}</p>
    </div>
  </aero-accordion-tab>

  <!-- Testing MacMillan 3 Book Dialog -->
  <aero-accordion-tab panelValue="macMillan3Book"  class="columns medium-12">
    <span header>MacMillan 3 Book Dialog</span>
    <div content>
      <aero-button label="MacMillan 3 Book Dialog"
                   (onClick)="testBookDialog()">
      </aero-button>
    </div>
  </aero-accordion-tab>

  <!-- Testing a button that we pipe a keyword to translate -->
  <aero-accordion-tab panelValue="angularAndAjsTranslations"  class="columns medium-12">
    <span header>Angular and AJS Translations</span>
    <div content>
      <dl *transloco="let t">
        <dt>A Translated string from the AngularJS translations:</dt>
        <dd><pre>{{ t('ajs.account_settings_period_MONTH') }}</pre></dd>
        <dt>A Translated string from the Angular2+ translations:</dt>
        <dd><pre>{{ t('parentAccounts.heading') }}</pre></dd>

      </dl>
      <br/><br/><br/>
      <!-- Testing a button that we pipe a keyword to translate -->
      <aero-button></aero-button>
    </div>
  </aero-accordion-tab>

  <!-- Testing the Audio Recording Modal -->
  <aero-accordion-tab panelValue="audioRecording"  class="columns medium-12">
    <span header>Audio Recording Modal</span>
    <div content>
      <aero-button label="Audio Record Dialog"
                   (onClick)="testAudioRecord();">
      </aero-button>
    </div>
  </aero-accordion-tab>

  <!-- Testing the Aero button component: =================================== -->
  <aero-accordion-tab panelValue="aeroButtons"  class="columns medium-12">
    <span header>Aero Buttons</span>
    <div content>
      <bulb-button-styles></bulb-button-styles>
    </div>
  </aero-accordion-tab>

  <!-- Testing of the Aero Calender Picker component -->
  <aero-accordion-tab #aeroCalender panelValue="aeroCalender" class="columns medium-12">
    <span header>Aero Calender Picker</span>
    <div content *ngIf="aeroCalender.selected">
      <div class="row">
  <div class="columns medium-5">
    <h5>Aero Calendar with Month Picker: </h5>
    <aero-calendar-picker [placeholder]="'Please select end date'"
                [inputId]="'end-date'"
                [dateFormat]="'mm/yy'"
                [hintMessage]="'MM/YYYY'"
                [pickerView]="'month'"
                [required]="true"
                [yearRange]="'1950:2030'"
                [errorMessage]="'Wrong end date'"
                [label]="'End Date'">
    </aero-calendar-picker>
  </div>
      </div>

      <div class="row">
  <div class="columns medium-5">
          <h5>Aero Calendar with Month Picker with Min (02/1970) and Max (Today's month)
            Validation: </h5>
    <aero-calendar-picker [placeholder]="'Please select end date'"
                [inputId]="'end-date'"
                [dateFormat]="'mm/yy'"
                [hintMessage]="'MM/YYYY'"
                [pickerView]="'month'"
                [minDate]="user.startDate"
                [maxDate]="user.endDate"
                [required]="true"
                [yearRange]="'1950:2030'"
                [errorMessage]="'Wrong end date'"
                [label]="'End Date'">
    </aero-calendar-picker>
  </div>
      </div>

      <div class="row">
  <div class="columns medium-5">
    <h5>Aero Calendar with Date Picker: </h5>
    <aero-calendar-picker [inputId]="'birthDate'"
                [yearRange]="'1950:2030'"
                [required]="true"
                [errorMessage]="'Wrong date of birth'"
                [label]="'Date of Birth'">
    </aero-calendar-picker>
  </div>
      </div>

      <div class="row">
  <div class="columns medium-5">
          <h5>Aero Calendar with Date Picker with Min (15/01/1970) and Max (Today's date)
            Validation: </h5>
    <aero-calendar-picker [inputId]="'birthDate'"
                [yearRange]="'1950:2030'"
                [required]="true"
                [minDate]="user.startDate"
                [maxDate]="user.endDate"
                [errorMessage]="'Wrong date of birth'"
                [label]="'Date of Birth'">
    </aero-calendar-picker>
  </div>
      </div>

      <div class="row">
  <div class="columns medium-5">
    <h5>Aero Calendar with disabled state: </h5>
    <aero-calendar-picker [inputId]="'birthDate'"
                [yearRange]="'1950:2030'"
                [required]="true"
                [(ngModel)]="user.birthDate"
                [disabled]="true"
                [errorMessage]="'Wrong date of birth'"
                [label]="'Date of Birth'">
    </aero-calendar-picker>
  </div>
      </div>
    </div>
  </aero-accordion-tab>

  <!-- Testing of the Aero Input component -->
  <aero-accordion-tab #aeroInput panelValue="aeroInput" class="columns medium-12">
    <span header>Aero Input</span>
    <div content *ngIf="aeroInput.selected">
      <div class="row">
  <div class="columns medium-5">
    <h5>Basic Input: </h5>
    <aero-input [type]="'text'"
          [label]="'First Name'">
    </aero-input>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns medium-5">
    <h5>With form criteria label Input: </h5>
    <aero-input [type]="'text'"
          [placeholder]="'mm/dd/yyyy'"
          [hintMessage]="'mm/dd/yyyy'"
          [label]="'Date of birth'">
    </aero-input>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns medium-5">
    <h5>Pre populated value and placeholder Input: </h5>
    <aero-input [type]="'text'"
          [placeholder]="'Please enter the email'"
          [(ngModel)]="user.email"
          [name]="'email'"
          [label]="'Email'">
    </aero-input>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns medium-5">
    <h5>Required field with form criteria label & default error message on Input: </h5>
    <aero-input [type]="'email'"
          [required]="true"
          [label]="'Email'"
          [hintMessage]="'testuser@bulbapp.com'">
    </aero-input>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns medium-5">
    <h5>Required field with form criteria label & custom error message on Input: </h5>
    <aero-input [type]="'email'"
          [required]="true"
          [label]="'Email'"
          [hintMessage]="'testuser@bulbapp.com'"
          [errorMessage]="'Email is required with correct format'">
    </aero-input>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns medium-5">
    <h5>Disabled Input: </h5>
    <aero-input [type]="'email'"
          [label]="'Email'"
          [(ngModel)]="user.email"
          [name]="'email'"
          [disabled]="true">
    </aero-input>
  </div>
      </div>
    </div>
  </aero-accordion-tab>

  <!-- Testing of the Aero Textarea component -->
  <aero-accordion-tab #aeroTextarea panelValue="aeroTextarea" class="columns medium-12">
    <span header>Aero Textarea</span>
    <div content *ngIf="aeroTextarea.selected">
      <div class="row">
  <div class="columns">
    <h5>Basic Textarea: </h5>
    <aero-textarea [label]="'Description'">
    </aero-textarea>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns">
    <h5>Textarea with pre populated value, placeholder and limit as 80: </h5>
    <aero-textarea [label]="'Description'"
             [(ngModel)]="user.companyDetails"
             [name]="'companyDetails'"
             [maxlength]="80"
             [placeholder]="'Description of the page'">
    </aero-textarea>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns">
          <h5>Textarea with autosize enabled, with rows as 3 and column as 40: </h5>
    <aero-textarea [label]="'Description'"
             [placeholder]="'Description of the page'"
                   [rows]="3"
             [columns]="40"
             [autoResize]="true">
    </aero-textarea>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns">
    <h5>Required field with default error message on Textarea: </h5>
    <aero-textarea [label]="'Description'"
             [required]="true">
    </aero-textarea>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns">
    <h5>Required field with custom error message on Textarea: </h5>
    <aero-textarea [label]="'Description'"
             [errorMessage]="'Description is required with limit as 160.'"
             [required]="true">
    </aero-textarea>
  </div>
      </div>
      <br/>
      <div class="row">
  <div class="columns">
    <h5>Disabled Textarea: </h5>
    <aero-textarea [label]="'Description'"
             [(ngModel)]="user.companyDetails"
             [name]="'companyDetails'"
             [placeholder]="'Description of the page'"
             [disabled]="true">
    </aero-textarea>
  </div>
      </div>
        </div>
      </aero-accordion-tab>

  <!-- Testing of the Aero Form component -->
  <aero-accordion-tab #aeroForm panelValue="aeroForm" class="columns medium-12">
    <span header>Aero Form</span>
    <div content class="row" *ngIf="aeroForm.selected">
  <div class="columns medium-5">
    <h5>Aero Form: </h5>
    <aero-form [submitButtonLabel]="'Save'"
           [showCancelButton]="true">
      <aero-input [label]="'First Name'"
            [name]="'firstName'"
            [required]="true"
            [(ngModel)]="user.firstName">
      </aero-input>
      <aero-input [label]="'Last Name'"
            [name]="'lastName'"
            [required]="true"
            [(ngModel)]="user.lastName">
      </aero-input>
      <aero-input [label]="'Email'"
            [name]="'email'"
            [disabled]="true"
            [required]="true"
            [(ngModel)]="user.email">
      </aero-input>
      <aero-textarea [label]="'Company Details'"
               [name]="'companyDetails'"
               [columns]="45"
               [required]="true"
               [autoResize]="true"
               [(ngModel)]="user.companyDetails"
               [maxlength]="80">
      </aero-textarea>
    </aero-form>
  </div>
    </div>
  </aero-accordion-tab>

  <!-- Testing the built in Angular validation directives with our custom aero input component. -->
  <!-- Angular built in maxlength validator test -->
  <aero-accordion-tab #validationDirectives panelValue="angularValidation" class="columns medium-12">
    <span header>Angular Validation Directives</span>
    <div content *ngIf="validationDirectives.selected">
      <div class="row">
  <div class="columns medium-7">
    <h5>Angular built in maxlength validator test:</h5>
    <label for="maxlengthTest">You should only be allowed to type in 10 characters.</label>
    <aero-input type="text"
          [required]="false"
          name="maxlengthTest"
          [maxlength]="10"
          (aeroInputNgModelEmitter)="handleInputModelChanges( $event )">
    </aero-input>
    <p *ngIf="( inputFormControl.control && inputFormControl.control.value.length === 10 )"
       style="color: #C42D4E; font-size: 14px">
            Yo homie! We get it! you like to type however plez stawp. You can only type in 10
            characters in this input field -- thanks! No leave me alone -.-'
    </p>
  </div>
      </div>
      <br/>
      <!-- Angular built in minlength validator test -->
      <div class="row">
  <div class="columns medium-7">
    <h5>Angular built in minlength validator test:</h5>
          <label for="minlengthTest">Warning should display if the user has less then
            5 characters:</label>
    <aero-input type="text"
          [required]="false"
          name="minlengthTest"
          [ngModel]="'Yay to the biggest Yeet!'"
          [errorMessage]="'Name should have at least 5 characters ya silly goof!'"
          [minlength]="5"
          (aeroInputNgModelEmitter)="handleInputModelChanges( $event )">
    </aero-input>
    <p *ngIf="( inputFormControl.errors && inputFormControl.errors.minlength )" style="color: #C42D4E; font-size: 14px">
            This should also show, just to indicate we can propogate those errors form child to
            parent component. If the developer wanted / needed that for some reason yat y33t dab!
    </p>
  </div>
      </div>
      <br/>
      <!-- Angular built in email validator test. Valid email or not? -->
      <div class="row">
  <div class="columns medium-7">
    <h5>Angular built in email validator test:</h5>
          <label for="emailTest">Should check to see if the email entered has a valid format.
            ( It does nothing else )</label>
    <aero-input type="email"
          [required]="false"
          name="emailTest"
          placeholder="Please enter in your email:"
          [errorMessage]="'Something is wrong with that email address. Please check it.'"
          [email]="true"
          (aeroInputNgModelEmitter)="handleInputModelChanges( $event )">
    </aero-input>
    <p *ngIf="( inputFormControl.errors && inputFormControl.errors.email )" style="color: #C42D4E; font-size: 14px">
      Come on ya silly goof-ball! That isn't a valid email ya goob!
    </p>
  </div>
      </div>
      <br/>
      <!-- Angular built in pattern validator test. -->
      <div class="row">
  <div class="columns medium-11">
    <h5>Angular built in pattern validator test:</h5>
    <label for="patternTest">
      Should check if the username the user entered is allowed :
    </label>
    <aero-input type="text"
          [required]="false"
          name="patternTest"
          placeholder="Please enter in your username:"
          [errorMessage]="'Choose a bulb username. Sorry, no spaces or special characters.'"
          [pattern]="'[A-Za-z0-9_-]+'"
          (aeroInputNgModelEmitter)="handleInputModelChanges( $event )">
    </aero-input>
    <p *ngIf="( inputFormControl.errors && inputFormControl.errors.pattern )" style="color: #C42D4E; font-size: 14px">
      Please choose a better username, one that is actually cool! Like bulbie4life.
    </p>
  </div>
      </div>
      <br/><br/>

      <!-- Testing multiple validators at one! -->
      <div class="row">
  <div class="columns medium-11">
    <h5>Angular multiple built in validator tests:</h5>
    <label for="multipleValidatorTests">
      Should validate minlength, maxlength, and pattern.
    </label>
    <aero-input type="text"
          [required]="false"
          name="multipleValidatorTests"
          [ngModel]="'tiru5_'"
          [errorMessage]="'multiple validator tests'"
          [maxlength]="10"
          [minlength]="2"
          [pattern]="'[A-Za-z0-9_-]+'"
          (aeroInputNgModelEmitter)="handleMultipleInputModelChanges( $event )">
    </aero-input>
    <div *ngIf="( inputFormMultipleTest.errors )" style="color: #C42D4E; font-size: 14px">
      <p *ngIf="inputFormMultipleTest.errors.pattern">
        For real? Please choose a valid username, don't be lame.
      </p>
      <p *ngIf="inputFormMultipleTest.errors.minlength">
        Must be more than 2 characters.
      </p>
    </div>
  </div>
      </div>

    </div>
  </aero-accordion-tab>

  <aero-accordion-tab panelValue="iconLibrary" class="columns medium-12">
    <span header>Icon Library</span>
    <div content>
      <bulb-all-icons></bulb-all-icons>
    </div>
  </aero-accordion-tab>

  <aero-accordion-tab #swiperImageCarousel panelValue="swiperImageCarousel" class="columns medium-12">
    <span header>Swiper Image Carousel</span>
    <div content *ngIf="swiperImageCarousel.selected">
      <!--Swiper Image Carousel-->
      <div class="row">
        <div class="columns">
          <h5>Angular Image Carousel:</h5>
          <div class="bulb-image-carousel-icon">
            <i class="fa fa-plus-square"
               aria-hidden="true"
               (click)="addSlide()"></i>
            <i class="fa fa-minus-square"
               aria-hidden="true"
               (click)="removeSlide()"></i>
          </div>
          <bulb-image-carousel (changeActiveIndex)="currentIndexOfSlide($event)"
                     [slides]="slides">
          </bulb-image-carousel>
        </div>
      </div>
    </div>
  </aero-accordion-tab>

  <aero-accordion-tab panelValue="menuDemos" class="columns medium-12">
    <span header>Menu Demos</span>
    <div content>
      <bulb-menu-list-demos></bulb-menu-list-demos>
    </div>
  </aero-accordion-tab>

  <aero-accordion-tab panelValue="uppyDemos" class="columns medium-12">
    <span header>Uppy Demos</span>
    <div content>
      <bulb-uppy-dashboard-demos></bulb-uppy-dashboard-demos>
    </div>
  </aero-accordion-tab>

  <aero-accordion-tab panelValue="standardAeroDialog" class="columns medium-12">
    <span header>Test Standard Aero Dialog</span>
    <div content>
      <div class="dialog-margin">
        <aero-button label="Launch Standard Dialog"
                   (onClick)="showStandardDialog()">
        </aero-button>
      </div>
      <div>
        <aero-button label="Launch Standard Dialog with input"
                   (onClick)="showStandardDialogInput()">
        </aero-button>
      </div>
      <aero-input id="testFocusInput" [label]="'Test Focus After Close'"></aero-input>
    </div>
  </aero-accordion-tab>

</aero-accordion>

<!-- Testing of the Aero Accordion component -->
<div class="row">
  <div class="columns medium-12">
    <h5>Basic Accordion: </h5>
    <aero-accordion>
      <aero-accordion-tab panelValue="accordingTitle1">
        <span header>
          Accordion Title - 1
        </span>
        <div content>
          <aero-textarea [label]="'Share information about yourself'"
                         [columns]="textAreaColumns"
                         [autoResize]="true">
          </aero-textarea>
          <button>Save</button>
        </div>
      </aero-accordion-tab>
      <aero-accordion-tab panelValue="accordionTitle2">
        <span header>
          Accordion Title - 2
        </span>
        <div content>
          <aero-input [label]="'School Name'"></aero-input>
          <aero-input [label]="'Degree Earned'"></aero-input>
          <button>Save</button>
        </div>
      </aero-accordion-tab>
    </aero-accordion>
  </div>
</div>

<hr/>
